const STORAGE_KEY = "admin-settings";

export interface AdminSettings {
  autosaveInterval: number; // in milliseconds, 0 means disabled
}

const DEFAULT_SETTINGS: AdminSettings = {
  autosaveInterval: 120000, // 2 minutes
};

export const AUTOSAVE_OPTIONS = [
  { label: "Every 30 seconds", value: 30000 },
  { label: "Every 1 minute", value: 60000 },
  { label: "Every 2 minutes", value: 120000 },
  { label: "Every 5 minutes", value: 300000 },
  { label: "Disabled", value: 0 },
] as const;

export function getAdminSettings(): AdminSettings {
  if (typeof window === "undefined") {
    return DEFAULT_SETTINGS;
  }

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored) as Partial<AdminSettings>;
      return { ...DEFAULT_SETTINGS, ...parsed };
    }
  } catch {
    // If parsing fails, return defaults
  }

  return DEFAULT_SETTINGS;
}

export function setAdminSettings(settings: Partial<AdminSettings>): void {
  if (typeof window === "undefined") {
    return;
  }

  try {
    const current = getAdminSettings();
    const updated = { ...current, ...settings };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));

    // Dispatch a custom event so other components can react to settings changes
    window.dispatchEvent(new CustomEvent("admin-settings-changed", { detail: updated }));
  } catch {
    // If storage fails, fail silently
  }
}

export function getAutosaveLabel(interval: number): string {
  const option = AUTOSAVE_OPTIONS.find((o) => o.value === interval);
  return option?.label || "Custom";
}
